module.exports = __webpack_public_path__ + "img/system6.d777075f.png";